export const filterOption = (input: string, option: any): boolean => {
    const val = option?.name || option?.children.props.children || option?.children || '';
    return val.toLowerCase().includes(input.toLowerCase());
};
